import * as actionType from "../constants";
import * as commonData from "../Common";
import { push } from "react-router-redux";

export const storesingleboard = (inputs) => async (dispatch) => {
  const apiurl = commonData.commonData().apiUrl;
  dispatch({ type: actionType.ADDING_SINGLE_BOARD });
  try {
    const response = await fetch(`${apiurl}board/create`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();

    if (rdata.code === 200) {
      dispatch({
        type: actionType.CREATE_SINGLE_BOARD,
        payload: {
          board: rdata.data,
          code: rdata.code,
          message: rdata.message,
          status: rdata.status,
          redirect: true,
        },
      });
    } else {
      dispatch({
        type: actionType.CREATE_SINGLE_BOARD,
        payload: {
          board: "",
          code: rdata.code,
          message: rdata.message,
          status: rdata.status,
          redirect: false,
        },
      });
    }

    setTimeout(() => {
      dispatch({ type: actionType.BOARD_MESSAGE_DEACTIVATE });
    }, 4000);
  } catch (error) {
    console.log(error);
  }
};
